import React, { useState } from "react";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Avatar, Box, Card, IconButton, Typography, useTheme } from "@mui/material";
import { EmployeeCardActionButton } from "components/ActionButton/EmployeeCardActionButton";
import { IUser } from "models/Employee";

interface IEmployeeCard {
  employees: IUser;
  selectedUser: IUser | null;
  setSelectedUser: (user: IUser) => void;
}

const EmployeeCard = ({ employees, selectedUser, setSelectedUser }: IEmployeeCard) => {
  const theme = useTheme();
  const { profile_image, first_name, last_name, position, department, email, phone } = employees;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (e: React.MouseEvent<HTMLButtonElement>, employees: IUser) => {
    setAnchorEl(e.currentTarget);
    setSelectedUser(employees);
    console.log("Employee:", employees);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Card
        className="employee-card"
        variant="outlined"
        sx={{
          bgcolor: "#F5F6F9",
          borderRadius: "10px",
          borderWidth: "2px",
          margin: "auto",
          minWidth: "300px",
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between" padding={1}>
          <Box>
            <Avatar
              src={profile_image}
              alt={`${first_name} ${last_name}`}
              sx={{ width: 100, height: 100, border: "3px solid lightgrey" }}
            />
            <Box display="flex" alignItems="center">
              <Typography
                variant="h6"
                sx={{ fontSize: "16px", fontWeight: 800, mt: 1, opacity: 0.8 }}
              >
                {first_name}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontSize: "16px",
                  fontWeight: 800,
                  mt: 1,
                  ml: 1,
                  opacity: 0.8,
                }}
              >
                {last_name}
              </Typography>
            </Box>
            <Typography
              variant="h6"
              sx={{ color: theme.palette.primary.main, fontSize: "15px", mt: 1, fontWeight: 800 }}
            >
              {position && position.title}
            </Typography>
          </Box>

          <IconButton
            onClick={(e) => handleMenuOpen(e, employees)}
            sx={{ display: "flex", alignSelf: "self-start" }}
          >
            <MoreHorizIcon
              sx={{
                backgroundColor: "#F5F6F9",
                width: 26,
                height: 26,
                borderRadius: "100%",
              }}
            />
          </IconButton>
        </Box>
        <Box bgcolor="#fff" padding={1} margin={1} borderRadius="10px">
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="subtitle2" sx={{ fontSize: "14px", opacity: 0.8 }}>
                Department
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: "14px",
                  mt: 1,
                  opacity: 0.8,
                  color: theme.palette.primary.main,
                  fontWeight: "800",
                }}
              >
                {department && department.title}
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontSize: "14px", opacity: 0.8 }}>
                Hired Date
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: "14px",
                  mt: 1,
                  opacity: 0.8,
                  color: theme.palette.primary.main,
                  fontWeight: "800",
                }}
              >
                10/09/96
              </Typography>
            </Box>
          </Box>
          <Box mt={2}>
            <Box display="flex" alignItems="center" mb={1}>
              <EmailOutlinedIcon fontSize="small" />
              <Typography variant="subtitle2" sx={{ ml: 1 }} fontWeight={800}>
                {email}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <LocalPhoneOutlinedIcon fontSize="small" />
              <Typography variant="subtitle2" sx={{ ml: 1 }} fontWeight={800}>
                {phone}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Card>
      {selectedUser && (
        <EmployeeCardActionButton
          anchorEl={anchorEl}
          open={open}
          handleClose={handleMenuClose}
          userData={employees}
          setUserData={setSelectedUser}
        />
      )}
    </>
  );
};

export default EmployeeCard;
